import React, { useState } from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root'); 

interface VideoComponentProps {
  data: string | null; 
  dataIndex: number;
}

const VideoComponent: React.FC<VideoComponentProps> = ({ data, dataIndex }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);  

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
     setModalIsOpen(false);
  };



  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "unset !importent",
      padding: "0 !important",
      border: "none !important",
      width: "500px",
    },
  };
  return (
    <>
      <video
        onClick={openModal}  
        style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '12px', cursor: 'pointer' }}
        muted
      >
        <source src={data ? data : '/assets/img/explore_placeholder.png'} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <Modal
        isOpen={modalIsOpen}  
        onRequestClose={closeModal} 
        contentLabel="Video Modal"
        className="modal-content"  
          style={customStyles}

      >
       

       <h5 style={{  textAlign: 'left' }}>Video</h5> 


       <i
          className="fa fa-times-circled fa-trash-css"
          onClick={closeModal}
          role="button"
        ></i>

        <video controls style={{ width: '100%', height: 'auto' }}>
          <source src={data ? data : '/assets/img/explore_placeholder.png'} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Modal>
    </>
  );
};

export default VideoComponent;
